var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeIconGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EBC4DD81-6A8F-4FE4-817A-B9DAE4AEB5D0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guidemark-Admin-Desktop-Schedule-time-view",
    transform: "translate(-721.000000, -79.000000)",
    fill: "#D2D2DB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Blocks-/-Blue",
    transform: "translate(721.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,12 L16,14.7188148 C16,15.4263704 15.4263704,16 14.7188148,16 L10.1700741,16 C9.46251852,16 8.88888889,15.4263704 8.88888889,14.7188148 L8.88888889,12 L8.88888889,1.28118519 C8.88888889,0.57362963 9.46251852,-1.0125234e-13 10.1700741,-1.0125234e-13 L14.7188148,-1.0125234e-13 C15.4263704,-1.0125234e-13 16,0.57362963 16,1.28118519 L16,12 Z M7.11111111,12.4 L7.11111111,14.7188148 C7.11111111,15.4263704 6.53748148,16 5.82992593,16 L1.28118519,16 C0.57362963,16 8.08242362e-13,15.4263704 8.08242362e-13,14.7188148 L8.08242362e-13,12.4 L8.08242362e-13,1.28118519 C8.08242362e-13,0.57362963 0.57362963,-3.23296945e-13 1.28118519,-3.23296945e-13 L5.82992593,-3.23296945e-13 C6.53748148,-3.23296945e-13 7.11111111,0.57362963 7.11111111,1.28118519 L7.11111111,12.4 Z",
    id: "Combined-Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIconGrey);
export default __webpack_public_path__ + "static/media/time-icon-grey.9f927c0ff32a24f7a3f1e3971ea3216f.svg";
export { ForwardRef as ReactComponent };